import { getAuthAxiosBackend } from "../helpers/axios"

class AboutServices{

    constructor(){
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('about', {params: data})
    }

    edit(id, about){
        about.append('_method', 'put')
        return getAuthAxiosBackend().post('about' + '/' + id, about)
    }
}

export default new AboutServices()